export default __webpack_public_path__ + "static/media/VictorUemura.6a8d851c.jpeg";